// extracted by mini-css-extract-plugin
export default {"title":"StripeTitle_title__PZXrF","icon":"StripeTitle_icon__2ebWU","text":"StripeTitle_text__O51-T"};